import { useCallback } from 'react';
import { useDebounce } from '@/hooks/usePerformance';
import { logger } from '@/utils/logger';

interface ValidationErrors {
  amount?: string;
  [key: string]: string | undefined;
}

export const useTransactionFormValidation = (setErrors: (errors: ValidationErrors | ((prev: ValidationErrors) => ValidationErrors)) => void) => {
  // Debounce amount validation for better UX
  const debouncedValidateAmount = useDebounce((value: string) => {
    logger.debug('=== DEBOUNCED AMOUNT VALIDATION ===', { value });
    
    const numericValue = parseFloat(value);
    logger.debug('Validation check', { 
      numericValue, 
      isNaN: isNaN(numericValue), 
      isLessThanOrEqualZero: numericValue <= 0 
    });
    
    if (isNaN(numericValue) || numericValue <= 0) {
      logger.debug('Setting amount error');
      setErrors((prev) => ({ ...prev, amount: 'Valor deve ser maior que zero' }));
    } else {
      logger.debug('Clearing amount error');
      setErrors((prev) => {
        const { amount, ...rest } = prev;
        return rest;
      });
    }
  }, 300);

  const clearFieldError = useCallback((field: string) => {
    setErrors((prev) => {
      const { [field]: removed, ...rest } = prev;
      return rest;
    });
  }, [setErrors]);

  return {
    debouncedValidateAmount,
    clearFieldError
  };
};

// Export as default export for compatibility
export default useTransactionFormValidation;